import React, {useState} from "react";
import {IMultiSelectOption} from "@components/elements/FiltersToolbar";
import Select from "react-select";
import cx from "classnames";


interface IMultiSelectFieldProps {
    /** A unique identifier for the field. */
    id: string

    /** The value of the field. */
    inputValue?: string;


    /** The options to display in the dropdown, as an array of objects with a `value` and `label` property. */
    options: IMultiSelectOption[]

    /** The selected values
     * @param {string[]} e
     */
    onChange: (e: string[]) => void


    /** The class name to apply to the field.
     * @param {string} e
     */
    className: string

    /** The placeholder text to display in the field.
     * @default "Select..."
     * @type {string}
     */
    placeholder?: string

    /** The label to display above the field.
     * @param {string} e
     */
    label?: string

    /** The selected values
     * @param {string[]} e
     */
    values: string[]

    /** The number of options visible in the dropdown.
     * @default 10
     */
    visibleOptions?: number
}

export default function MultiSelectField(props: IMultiSelectFieldProps) {

    const [placeholder] = useState(props.placeholder || "Select...");
    const [maxItemsInList] = useState(props.visibleOptions || 500);
    const [inputValue, setInputValue] = useState<string>(props.inputValue || "");

    function getOptions() {
        if (inputValue.length > 0) {
            return props.options.filter((option) => option.getLabel().toLowerCase().includes(inputValue.toLowerCase())).slice(0, maxItemsInList).map((option) => {
                return {value: option.getSlug(), label: option.getLabel()}
            });
        }
        return props.options.slice(0, maxItemsInList).map((option) => {
            return {value: option?.getSlug(), label: option?.getLabel()}
        });
    }

    return (
        <div className={[
            props.className,
        ].join(" ")}>
            <Select
                id={props.id}
                instanceId={props.id}
                isMulti={true}
                onChange={(e) => props.onChange(e.map((item) => item.value))}
                classNamePrefix={props.id}
                className={cx("w-full", "h-full", "text-gray-900 dark:text-gray-100", "rounded-md", "bg-gray-100 border border-2", "dark:bg-gray-500 dark:border-gray-700 dark:text-gray-100")}
                placeholder={placeholder}
                onInputChange={(e) => setInputValue(e)}
                options={getOptions()}
                filterOption={() => true}
                value={props.options.filter((item) => props.values.includes(item.getSlug())).map((item) => {
                    return {value: item.getSlug(), label: item.getLabel()}
                })}
            />
            {/* eslint-disable-next-line react/no-unknown-property */}
            <style global jsx>{`
              #${props.id} .${props.id}__control {
                height: 100%;
              }

              .dark #${props.id} .${props.id}__control,
              :root[data-theme='dark'] #${props.id} .${props.id}__control {
                background-color: #6b727f !important;
                border-color: #2b2b2b00;
                padding: 4px;
                height: 100%;
              }

              .dark #${props.id} .${props.id}__placeholder,
              :root[data-theme='dark'] #${props.id} .${props.id}__placeholder {
                color: #d1d5db !important;
              }

              .dark #${props.id} .${props.id}__multi-value,
              :root[data-theme='dark'] #${props.id} .${props.id}__multi-value {
                background-color: slategray;
                color: #fff;
              }

              .dark #${props.id} .${props.id}__input-container,
              :root[data-theme='dark'] #${props.id} .${props.id}__input-container {
                color: #d1d5db;
                border: none;
              }

              .dark #${props.id} .${props.id}__input-container:focus,
              :root[data-theme='dark'] #${props.id} .${props.id}__input-container:focus {
                border: none !important;
                outline: none !important;
              }

              .dark #${props.id} .${props.id}__input:focus,
              :root[data-theme='dark'] #${props.id} .${props.id}__input:focus {
                border: none !important;
                outline: none !important;
              }

              .dark #${props.id} .${props.id}__input::after,
              :root[data-theme='dark'] #${props.id} .${props.id}__input::after {
                border: none !important;
                display: none;
              }

              .dark #${props.id} .${props.id}__multi-value__label,
              :root[data-theme='dark'] #${props.id} .${props.id}__multi-value__label {
                color: #fff;
              }

              .dark #${props.id} .${props.id}__menu,
              :root[data-theme='dark'] #${props.id} .${props.id}__menu {
                background-color: #2d3748;
              }

              .dark #${props.id} .${props.id}__option,
              :root[data-theme='dark'] #${props.id} .${props.id}__option {
                color: #fff;
              }

              .dark #${props.id} .${props.id}__option--is-focused,
              :root[data-theme='dark'] #${props.id} .${props.id}__option--is-focused {
                background-color: slategray;
              }
            `}</style>
        </div>
    )
}
